import { render, staticRenderFns } from "./loggers.vue?vue&type=template&id=0b279e2c&"
import script from "./loggers.vue?vue&type=script&lang=js&"
export * from "./loggers.vue?vue&type=script&lang=js&"
import style0 from "./loggers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports